import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";
interface CartItemRemoveButtonProps {
  onRemove: () => void;
  disabled?: boolean;
}
export const CartItemRemoveButton = ({ onRemove, disabled = false }: CartItemRemoveButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="w-8 h-8 p-0 text-gray-400 hover:text-red-500 hover:bg-red-50"
      onClick={onRemove}
      disabled={disabled}
    >
      <Trash2 className="w-4 h-4" />
    </Button>
  );
};